import { render } from "./Thread.vue?vue&type=template&id=bf30314c&scoped=true"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"

import "./Thread.vue?vue&type=style&index=0&id=bf30314c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf30314c"]])

export default __exports__